import {
  FeatureFlagContext,
  FeatureFlagsLoadedContext,
  FlagDict,
} from "@src/lib/contexts/FeatureFlagContext";
import { recordFeatureFlagRequested } from "@src/features/app/utils/featureFlagUsage";
import { useContext } from "react";
import { Ff } from "@src/types.generated";

export const resolveFeatureFlag = (
  flags: FlagDict,
  flag: string | Ff,
): boolean => {
  recordFeatureFlagRequested(flag);
  if (window?.__PLAYWRIGHT_FEATURE_FLAG_OVERRIDES__?.[flag] !== undefined) {
    return window.__PLAYWRIGHT_FEATURE_FLAG_OVERRIDES__[flag];
  }
  return flags[flag] || false;
};

export const useFeatureFlag = (flag: string | Ff): boolean => {
  const flags = useContext(FeatureFlagContext);
  return resolveFeatureFlag(flags, flag);
};

export const useFeatureFlagsLoaded = (): boolean =>
  useContext(FeatureFlagsLoadedContext);
